// extracted by mini-css-extract-plugin
var _1 = "main-text__gGVEF";
var _2 = "main-text-hidden__FyAJ7";
var _3 = "more-details-text__aoSv_";
var _4 = "more-details-wrapper__v1eWx";
export { _1 as "mainText", _2 as "mainTextHidden", _3 as "moreDetailsText", _4 as "moreDetailsWrapper" }
